const Events = require('PSEvents');
const { GameStates } = require('ClientStates');
const PSEvents = require('./PSEvents');
const State = {
    set betAmount (value) { this._betAmount = value; },
    get betAmount () { return this._betAmount },

    _paylines: -1,
    _betAmount: 100,
    availableBetAmounts: [ 10, 20, 50, 100, 200, 500, 1000 ],

    balance: 500000,
    multiplier: 1,
    freeSpinRemaining: 0,
    gameState: GameStates.MAIN,
    prevGameState: '',
    freeRoundsData: null,
    gameConfiguration: null,


    // cui related
    progressPerBet: null,
    soundEnabled: true,
    musicVolume: 10,
    masterVolume: 10,
    fxVolume: 10,
    keyboardFeature: true,
    menuEnabled: false,
    quickSpinFeature: false,
    playHistoryEnabled: true,
    disabledFeatures: {},
    gameInnerCanvasSize: {
        top: {},
        topValue: 0,
        bottom: {},
        bottomValue: 0,
        left: {},
        leftValue: 0,
        right: {},
        rightValue: 0,
    },

    // autoplay
    selectedSpinIndex: 0,
    autoplaySpinRemaining: 0,
    availableNumberOfSpins: [10, 25, 50, 100, 250, 500, 1000, Number.MAX_SAFE_INTEGER ],
    autoplayMaxWinThreshold: 500,// 1000xbetAmount
    autoplayMaxLossThreshold: 100, // 1000xbetAmount
    autoplaySelectedMaxLoss: 0,// actual value (multiplied by betAmount)
    autoplaySelectedMaxWin: 0,

    // WINNING related
    //the difference is that on FS spinWinning is for each spin,
    //the bet winning is accumulated winning of entire FS,
    spinWinning: 0, // winning of each spin
    betWinning: 0, // winning of each betAmount,

    // BOOSTERS
    selectedBooster: null,
    // REDEEM
    redeemables: [],
    // replay
    stateBeforeReplay: null,

    isAutoplay () { return this.autoplaySpinRemaining > 0; },
    enable (arr) {
        arr.forEach((item) => this.disabledFeatures[item] = true );
        PSEvents.publish(PSEvents.FEATURE_STATE_UPDATED, this);
    },
    disable (arr) {
        arr.forEach((item) => this.disabledFeatures[item] = false );
        PSEvents.publish(PSEvents.FEATURE_STATE_UPDATED, this);
    },
    checkPlayerFunds () { return this.balance >= this.betAmount },

    isEnabled (item) {
        if (this.disabledFeatures.hasOwnProperty(item)) {
            return this.disabledFeatures[item];
        }
        return true;
    },

    incrementBet () {
        const index = this.availableBetAmounts.findIndex((element) => {
            return element === this.betAmount;
        });

        if (index < this.availableBetAmounts.length - 1) {
            this.set({
                betAmount: this.availableBetAmounts[index + 1]
            });
        }
    },

    decrementBet () {
        const index = this.availableBetAmounts.findIndex((element) => {
            return element === this.betAmount;
        });

        if (index > 0) {
            this.set({
                betAmount: this.availableBetAmounts[index - 1]
            });
        }
    },

    get () { return this; },
    set (obj, notify = true) {
        let betUpdated = false;
        for (const param in obj) {
            if (param) {
                this[param] = obj[param];
            }
            if (param === 'betAmount' || param === 'selectedBooster') {
                betUpdated = true;
            }
        }

        if (betUpdated) {
            Events.publish(Events.BET_CHANGED, {
                betAmount: this.betAmount,
                selectedBooster: this.selectedBooster
            });
        }

        if (notify) {
            Events.publish(Events.STATE_UPDATED, this);
        }
        storeData(this);
    },

    updateGameInnerCanvasSize(data) {
        if (data.top) {
            Object.assign(this.gameInnerCanvasSize.top, data.top);
            this.gameInnerCanvasSize.topValue =
                Object.values(this.gameInnerCanvasSize.top).reduce((s, item) => s + item, 0);
        }
        if (data.left) {
            Object.assign(this.gameInnerCanvasSize.left, data.left);
            this.gameInnerCanvasSize.leftValue =
                Object.values(this.gameInnerCanvasSize.left).reduce((s, item) => s + item, 0);
        }
        if (data.right) {
            Object.assign(this.gameInnerCanvasSize.right, data.right);
            this.gameInnerCanvasSize.rightValue =
                Object.values(this.gameInnerCanvasSize.right).reduce((s, item) => s + item, 0);
        }
        if (data.bottom) {
            Object.assign(this.gameInnerCanvasSize.bottom, data.bottom);
            this.gameInnerCanvasSize.bottomValue =
                Object.values(this.gameInnerCanvasSize.bottom).reduce((s, item) => s + item, 0);
        }

        PSEvents.publish(PSEvents.GAME_INNTER_CANVAS_SIZE_CHANGED, this.gameInnerCanvasSize);
    },
};

const propertiesToStore = {
    numbers: [
        'musicVolume',
        'masterVolume',
        'fxVolume',
        'selectedSpinIndex',
        'betAmount'
    ],
    booleans: ['soundEnabled', 'keyboardFeature' ]
};

const storeData = (data) => {
    try {
        propertiesToStore.numbers.forEach((property) => {
            if (data.hasOwnProperty(property)) {
                const dataToStore = data[property].toString();

                localStorage.setItem(property, dataToStore);
            }
        });
        propertiesToStore.booleans.forEach((property) => {
            if (data.hasOwnProperty(property)) {
                const dataToStore = data[property].toString();

                localStorage.setItem(property, dataToStore);
            }
        });
    } catch (e) { }
};

try {
    // retrieve data
    propertiesToStore.numbers.forEach((property) => {
        if (State.hasOwnProperty(property)) {
            let data = localStorage.getItem(property);

            if (data !== undefined && data !== null && data.length > 0) {
                State[property] = parseFloat(data);
            }
        }
    });
    propertiesToStore.booleans.forEach((property) => {
        if (State.hasOwnProperty(property)) {
            let data = localStorage.getItem(property);

            if (data !== undefined && data !== null && data.length > 0) {
                State[property] = !(data === "false");
            }
        }
    });
} catch (e) { };

export default State;
